<template>
    <div>
        <button class="btn btn-primary" @click="enviar">{{ url }}</button>
        <p>{{ text }}</p>
    </div>
</template>

<script>
import authService from '@/services/auth.service';
import { defineComponent } from 'vue';

export default defineComponent({
    mounted() {
        this.url = process.env.VUE_APP_URL
    },
    data() {
        return {
            text: 'hola',
            url: ''
        }
    },
    methods: {
        enviar() {
            authService.login('pepe')
            .then((res) => {
                console.log(res.data)
            })
            .catch((e) => {
                console.log(e)
            })
        }
    }
})
</script>